
import Vue from 'vue'

import { getRequest } from '@/plugins/api-axios'
import { deserialise } from 'kitsu-core'

import { PSI } from '@/views/Project/PSI/types/psi'

const PsiAutocomplete = Vue.extend({
    props: {
        baseUrl: {
            type: String,
            default: process.env.VUE_APP_PSI_BASE_URL,
        },
        endpoint: {
            type: String,
            default: 'psis',
        },
        filters: {
            type: null || Object,
            default: null,
        },
        include: {
            type: null || Array,
            default: null,
        },
        value: {
            type: null || Object,
            default: null,
        },
    },
    data() {
        return {
            items: [] as Array<PSI>,
            isDirty: false,
            searchTerm: '',
            loading: false,
            offset: 0,
            limit: 40,
            infiniteID: new Date().getTime(),
            psi: this.value,
        }
    },

    watch: {
        isDirty: {
            immediate: false,
            async handler() {
                if (this.isDirty) {
                    this.loading = true
                    await this.load()
                }
            },
        },
    },

    methods: {
        handleInput(e) {
            this.$emit('input', this.psi)
        },
        async load() {
            this.loading = true

            if (this.isDirty && this.searchTerm !== this.psi?.name) {
                this.offset = 0
                this.items = []
                this.infiniteID = new Date().getTime()
                this.items = await this.searchPSIs()
            }
            this.loading = false
        },

        async loadMore($state) {
            if (this.offset >= this.limit) {
                this.loading = true
                let res = await this.searchPSIs()
                if (!res) {
                    $state.complete()
                    return
                }
                this.items = [...this.items, ...res]

                if (res.length == this.limit) {
                    $state.loaded()
                } else {
                    $state.complete()
                }
                this.loading = false
            } else {
                $state.complete()
            }
        },

        async searchPSIs() {
            let { data } = await getRequest(
                this.getURL({
                    path: this.endpoint,
                    base: this.baseUrl,
                    params: {
                        ...(this.filters && { ...this.filters }),
                        'page[limit]': this.limit,
                        'page[offset]': this.offset,
                        ...(this.include && { include: this.include.join(',') }),
                    },
                }),
                this.getRequestHeaders('GET')
            ).catch(() => {
                this.loading = false
            })

            if (!data) {
                return null
            }

            let res = deserialise(data).data

            this.offset = this.offset + res.length

            return res
        },
    },
})

export default PsiAutocomplete
